<template>
  <v-container fluid class="mt-4 ml-2">
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="text-subtitle-1 flex-wrap">
            Meta Excel
            <v-spacer></v-spacer>
            <v-btn
              outlined
              small
              tile
              class="mr-2 mb-1"
              :loading="cargandoPreview"
              :disabled="!fechasOk"
              @click="preview()"
            >
              <v-icon left small>mdi-chart-box-outline</v-icon>
              Preview
            </v-btn>
            <v-btn
              color="primary"
              dark
              small
              tile
              class="mb-1"
              :loading="cargandoZip"
              :disabled="!fechasOk"
              @click="descargarZip()"
            >
              <v-icon left small>mdi-download</v-icon>
              Descargar ZIP
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="escuela"
                  :items="opcionesEscuela"
                  label="Escuela"
                  filled
                  dense
                  hide-details
                  item-text="text"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="fechaini"
                  dense
                  filled
                  hide-details
                  type="date"
                  label="Fecha inicio"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="fechafin"
                  dense
                  filled
                  hide-details
                  type="date"
                  label="Fecha final"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="text-caption grey--text mt-3">
              7 CSV para Meta. Embudo 1+2 → Exclusión; 3 → Remarketing; 4 → Examen no inscrito;
              5 → Compradores (todos / presencial / online / teens según nombre del grupo).
              SPAM excluido. Escuela + fechas.
            </div>

            <v-row v-if="conteos" dense class="mt-4">
              <v-col
                v-for="item in archivosMeta"
                :key="'kpi-' + item.key"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-sheet
                  rounded
                  class="pa-3 me-stat"
                  :class="[item.clase, { 'me-stat--active': tabActiva === 'tab-' + item.key }]"
                  style="cursor: pointer"
                  @click="tabActiva = 'tab-' + item.key"
                >
                  <div class="text-caption">{{ item.label }}</div>
                  <div class="text-h5 font-weight-bold">{{ conteos[item.key] || 0 }}</div>
                  <div class="text-caption grey--text text--darken-1 text-truncate">{{ item.filename }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-sheet rounded class="pa-3 me-stat me-stat--total">
                  <div class="text-caption">Total únicos embudo</div>
                  <div class="text-h5 font-weight-bold">{{ conteos.total || 0 }}</div>
                  <div class="text-caption grey--text text--darken-1">sin subtipos compradores</div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-alert
              v-if="ultimoMensaje"
              dense
              text
              colored-border
              border="left"
              color="info"
              class="mt-4 mb-0"
            >
              {{ ultimoMensaje }}
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="tieneDatos" class="mt-2">
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-tabs v-model="tabActiva" background-color="transparent" show-arrows>
            <v-tab
              v-for="item in archivosMeta"
              :key="'tab-' + item.key"
              :href="'#tab-' + item.key"
            >
              {{ item.label }}
              <v-chip x-small class="ml-2" :color="item.chip" label>
                {{ (filasPorArchivo[item.key] || []).length }}
              </v-chip>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabActiva">
            <v-tab-item
              v-for="item in archivosMeta"
              :key="'panel-' + item.key"
              :value="'tab-' + item.key"
            >
              <v-card-title class="py-2 flex-wrap">
                <span class="text-subtitle-2">{{ item.label }} · {{ item.filename }}</span>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="busquedas[item.key]"
                  dense
                  filled
                  hide-details
                  clearable
                  prepend-inner-icon="mdi-magnify"
                  label="Buscar"
                  class="me-search"
                ></v-text-field>
              </v-card-title>
              <v-card-text class="pt-0">
                <v-data-table
                  :headers="headers"
                  :items="filasPorArchivo[item.key] || []"
                  :search="busquedas[item.key]"
                  :items-per-page="25"
                  :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
                  dense
                  class="elevation-0"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item.phone="{ item: row }">
                    <span class="font-weight-medium">{{ row.phone || '—' }}</span>
                  </template>
                  <template v-slot:item.email="{ item: row }">
                    {{ row.email || '—' }}
                  </template>
                  <template v-slot:item.fn="{ item: row }">
                    {{ row.fn || '—' }}
                  </template>
                  <template v-slot:item.ln="{ item: row }">
                    {{ row.ln || '—' }}
                  </template>
                  <template v-slot:item.ct="{ item: row }">
                    {{ row.ct || '—' }}
                  </template>
                  <template v-slot:item.st="{ item: row }">
                    {{ row.st || '—' }}
                  </template>
                  <template v-slot:item.zip="{ item: row }">
                    {{ row.zip || '—' }}
                  </template>
                  <template v-slot:no-data>
                    <div class="pa-4 grey--text text-center">Sin registros en este archivo</div>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import validarErrores from '@/mixins/validarErrores'

function hoyLocal () {
  return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .substr(0, 10)
}

const ARCHIVOS_META = [
  {
    key: 'exclusion_spam',
    label: 'Exclusión / tempranos',
    filename: 'META_Exclusion_Spam_Invalidos.csv',
    clase: 'me-stat--1',
    chip: 'grey lighten-2',
  },
  {
    key: 'remarketing',
    label: 'Remarketing',
    filename: 'META_Remarketing_Sin_Respuesta.csv',
    clase: 'me-stat--3',
    chip: 'orange lighten-4',
  },
  {
    key: 'examen_no_inscrito',
    label: 'Examen no inscrito',
    filename: 'META_Examen_Realizado_No_Inscrito.csv',
    clase: 'me-stat--4',
    chip: 'purple lighten-4',
  },
  {
    key: 'compradores_todos',
    label: 'Compradores todos',
    filename: 'META_Compradores_Todos.csv',
    clase: 'me-stat--5',
    chip: 'green lighten-4',
  },
  {
    key: 'compradores_presencial',
    label: 'Compradores presencial',
    filename: 'META_Compradores_Presencial.csv',
    clase: 'me-stat--2',
    chip: 'blue lighten-4',
  },
  {
    key: 'compradores_online',
    label: 'Compradores online',
    filename: 'META_Compradores_Online.csv',
    clase: 'me-stat--online',
    chip: 'cyan lighten-4',
  },
  {
    key: 'compradores_teens',
    label: 'Compradores teens',
    filename: 'META_Compradores_Teens.csv',
    clase: 'me-stat--teens',
    chip: 'pink lighten-4',
  },
]

function filasVacias () {
  const o = {}
  ARCHIVOS_META.forEach((a) => { o[a.key] = [] })
  return o
}

function busquedasVacias () {
  const o = {}
  ARCHIVOS_META.forEach((a) => { o[a.key] = '' })
  return o
}

export default {
  name: 'MetaExcel',

  mixins: [validarErrores],

  data: () => ({
    fechaini: hoyLocal(),
    fechafin: hoyLocal(),
    escuela: 1,
    opcionesEscuela: [
      { text: 'INBI', value: 1 },
      { text: 'FAST', value: 2 },
    ],
    cargandoPreview: false,
    cargandoZip: false,
    conteos: null,
    filasPorArchivo: filasVacias(),
    busquedas: busquedasVacias(),
    tabActiva: 'tab-exclusion_spam',
    ultimoMensaje: '',
    headers: [
      { text: 'phone', value: 'phone' },
      { text: 'email', value: 'email' },
      { text: 'fn', value: 'fn' },
      { text: 'ln', value: 'ln' },
      { text: 'ct', value: 'ct' },
      { text: 'st', value: 'st' },
      { text: 'zip', value: 'zip' },
    ],
    archivosMeta: ARCHIVOS_META,
  }),

  computed: {
    fechasOk () {
      return !!(this.fechaini && this.fechafin && this.fechaini <= this.fechafin)
    },

    tieneDatos () {
      return !!(this.conteos && this.conteos.total != null)
    },
  },

  methods: {
    payload () {
      if (!this.fechasOk) {
        this.validarError('Selecciona un rango de fechas válido (inicio ≤ fin)')
        return null
      }
      return {
        fechaini: this.fechaini,
        fechafin: this.fechafin,
        escuela: Number(this.escuela) === 2 ? 2 : 1,
      }
    },

    mensajeErrorHttp (error, fallback) {
      return (
        (error && error.response && error.response.data && error.response.data.message) ||
        (error && error.message) ||
        fallback
      )
    },

    async preview () {
      const payload = this.payload()
      if (!payload) return
      this.cargandoPreview = true
      this.ultimoMensaje = ''
      try {
        const { data } = await this.$http.post('meta.excel.preview', payload)
        this.conteos = data.conteos || null
        const etapas = data.etapas || {}
        const filas = filasVacias()
        ARCHIVOS_META.forEach((a) => {
          filas[a.key] = etapas[a.key] || []
        })
        this.filasPorArchivo = filas
        this.tabActiva = 'tab-exclusion_spam'
        const escuelaLabel = payload.escuela === 2 ? 'FAST' : 'INBI'
        this.ultimoMensaje = `Preview ${escuelaLabel} · ${payload.fechaini} → ${payload.fechafin}: ${
          (data.conteos && data.conteos.total) || 0
        } contactos únicos`
      } catch (error) {
        this.validarError(this.mensajeErrorHttp(error, 'Error al consultar preview'))
      } finally {
        this.cargandoPreview = false
      }
    },

    async descargarZip () {
      const payload = this.payload()
      if (!payload) return
      this.cargandoZip = true
      this.ultimoMensaje = ''
      try {
        const response = await this.$http.post('meta.excel.zip', payload, {
          responseType: 'blob',
        })

        const contentType = (response.headers && response.headers['content-type']) || ''
        if (contentType.includes('application/json')) {
          const text = await response.data.text()
          let message = 'Error al generar ZIP'
          try {
            const parsed = JSON.parse(text)
            if (parsed && parsed.message) message = parsed.message
          } catch (_) { /* ignore */ }
          this.validarError(message)
          return
        }

        const blob = response.data instanceof Blob
          ? response.data
          : new Blob([response.data], { type: 'application/zip' })
        const href = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = href
        a.download = `meta_excel_${payload.escuela === 2 ? 'fast' : 'inbi'}_${payload.fechaini}_${payload.fechafin}.zip`
        a.click()
        URL.revokeObjectURL(href)

        this.ultimoMensaje = `ZIP descargado (${payload.escuela === 2 ? 'FAST' : 'INBI'})`
      } catch (error) {
        let message = this.mensajeErrorHttp(error, 'Error al descargar ZIP')
        try {
          if (error.response && error.response.data instanceof Blob) {
            const text = await error.response.data.text()
            const parsed = JSON.parse(text)
            if (parsed && parsed.message) message = parsed.message
          }
        } catch (_) { /* ignore */ }
        this.validarError(message)
      } finally {
        this.cargandoZip = false
      }
    },
  },
}
</script>

<style scoped>
.me-stat {
  border: 1px solid #eceff1;
  min-height: 96px;
}
.me-stat--1 { background: #fafafa; }
.me-stat--2 { background: #e3f2fd; }
.me-stat--3 { background: #fff3e0; }
.me-stat--4 { background: #f3e5f5; }
.me-stat--5 { background: #e8f5e9; }
.me-stat--online { background: #e0f7fa; }
.me-stat--teens { background: #fce4ec; }
.me-stat--total { background: #eceff1; }
.me-stat--active {
  box-shadow: inset 0 0 0 2px #1976d2;
}
.me-search {
  max-width: 280px;
}
</style>
